import SharedStore from 'shared/stores/shared.store'
import * as api from '../api/products.api'

class ProductsStore extends SharedStore {
  storeName = 'ProductsStore'
  childApi = api
}

export default new ProductsStore()
